// // import React, { useCallback, useEffect, useState } from "react";
// // import { Tables } from "../../../../components/Elements/Tables/Tables";
// // import { ReactComponent as BackIcon } from "../../../../assets/svgs/back-square.svg";
// // import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// // import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
// // import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
// // import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
// // import { Button } from "antd";
// // import AddNewSubSection from "./AddNew/AddNewSubSection";
// // import { useLocation } from "react-router-dom";
// // import { useNavigate } from "react-router-dom";
// // import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// // import { getApi } from "../../../../api/api_instance";
// // import { API_URLS } from "../../../../api/apiUrls";
// // import dayjs from "dayjs";
// // import UpdateSubSection from "./Update/UpdateSubSection";
// // import { Badge } from "../../../../components/Elements/TextStyles/Badge";
// // import { IoArrowBackCircleOutline } from "react-icons/io5";
// // const SubSections = () => {
// //   const [openAddNew, setOpenAddnew] = useState(false);
// //   const [openUpdate, setOpenUpdate] = useState(false);
// //   const navigate = useNavigate();
// //   // const [currentPage, setCurrentPage] = useState(1);
// //   const [tableData, setTableData] = useState([]);
// //   // const [totalRecords, setTotalRecords] = useState(0);
// //   // const [pageSize, setPageSize] = useState(2);
// //   const [sortOrder, setSortOrder] = useState("-createdAt");
// //   const [subSectionId, setSubSectionId] = useState("");
// //   const [subSectionName, setSubSectionName] = useState("");
// //   const [subSectionCreated, setSubSectionCreated] = useState(false);
// //   const [subSectionUpdated, setSubSectionUpdated] = useState(false);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const location = useLocation();
// //   const sectionId = location.state?.sectionId || "";

// //   const headers = [
// //     { label: "Sr. No.", key: "serial" },
// //     { label: "Sub Section", key: "subSection" },
// //     { label: "Status", key: "status" },
// //     { label: "Action", key: "action" },
// //   ];

// //   const fetchTableData = useCallback(
// //     async (sectionId) => {
// //       try {
// //         const response = await getApi({
// //           apiUrl: API_URLS.GET_SUBSECTIONS(sectionId),
// //         });

// //         if (response.success) {
// //           // setPageSize(response.limit);
// //           // setTotalRecords(response.total);
// //           setTableData(
// //             response.data.map((item, index) => ({
// //               key: item.key,
// //               serial: index + 1,
// //               subSection: item.name,
// //               createdOn: dayjs(item.createdAt).format("DD/MM/YYYY"),
// //               statusText: "ACTIVE",
// //               status: <Badge text={item.status} />,
// //               action: (
// //                 <div className="flex gap-4 items-center">
// //                   <EyeIcon
// //                     className=""
// //                     style={{ fontSize: "18px", cursor: "pointer" }}
// //                     onClick={() => {
// //                       navigate(
// //                         "/organization/my-question-bank/sub-section/questions",
// //                         {
// //                           state: {
// //                             subSectionId: item._id,
// //                             sectionId: sectionId,
// //                           },
// //                         },
// //                       );
// //                     }}
// //                   />
// //                   <EditIcon
// //                     style={{ fontSize: "18px", cursor: "pointer" }}
// //                     onClick={() => {
// //                       setOpenUpdate(true);
// //                       setSubSectionId(item._id);
// //                       setSubSectionName(item.name);
// //                     }}
// //                   />
// //                   <CustomSwitch
// //                     checked={true} // Default state
// //                     onChange={(checked) =>
// //                       console.log(`Custom switch toggled, Status: ${checked}`)
// //                     }
// //                   />
// //                 </div>
// //               ),
// //             })),
// //           );
// //         }
// //       } catch (error) {
// //         console.error("Error in fetching table data", error);
// //       }
// //     },
// //     [subSectionCreated],
// //   );

// //   const handleOpenAddNew = () => {
// //     setOpenAddnew(true);
// //   };

// //   // const handleSort = useCallback(() => {
// //   //   setSortOrder((prevOrder) =>
// //   //     prevOrder === "createdAt" ? "-createdAt" : "createdAt"
// //   //   );
// //   // }, []);

// //   // const handlePageChange = useCallback((page) => {
// //   //   setCurrentPage(page);
// //   // }, []);

// //   useEffect(() => {
// //     if (sectionId) {
// //       fetchTableData(sectionId);
// //     }
// //   }, [fetchTableData, subSectionUpdated, subSectionCreated]);

// //   const handleBack = () => {
// //     navigate("/organization/my-question-bank");
// //   };

// //   return (
// //     // <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">

// //     //    <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
// //     //       <p>Home</p>
// //     //       <span>/</span>
// //     //       <p>My Question Bank</p>
// //     //       <span>/</span>
// //     //       <p>Section</p>
// //     //       <span>/</span>
// //     //       <TextStyles style={{ color: "#06513D" }}>
// //     //         {" "}
// //     //      Sub Section
// //     //       </TextStyles>
// //     //     </div>

// //     //     <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
// //     //       <IoArrowBackCircleOutline
// //     //         onClick={() => navigate(-1)}
// //     //         className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
// //     //       />
// //     //       <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
// //     //       Sub Sections (Demo 155)
// //     //       </div>
// //     //     </div>

// //     //   <div
// //     //     style={{
// //     //       border: "1px solid #3BA2B959",
// //     //       borderRadius: "10px",
// //     //       paddingTop: "20px",
// //     //       boxShadow: "0px 0px 16px 0px #3BA2B91F",
// //     //       backgroundColor:"#ffff"
// //     //     }}
// //     //     className="pt-2 px-2"
// //     //   >
// //     //     <div className="flex justify-between mx-8 mb-4">
// //     //       <div className="flex items-center gap-5 ">
// //     //         <div
// //     //           style={{
// //     //             background: "#B6D4D933",
// //     //             height: "40px",
// //     //           }}
// //     //           className="border border-[#06513D] rounded-md text-[#06513D] text-base font-light "
// //     //         >
// //     //           <p
// //     //             style={{
// //     //               fontFamily: "Calibri",
// //     //               fontWeight: "300",
// //     //               fontSize: "16px",
// //     //               lineHeight: "24px",
// //     //               letterSpacing: "0%",
// //     //             }}
// //     //             className="pt-2 px-2"
// //     //           >
// //     //             TOTAL Section {tableData.length}
// //     //           </p>
// //     //         </div>
// //     //         <SearchBar
// //     //           onSearch={(value) => setSearchTerm(value)}
// //     //           width="300px"
// //     //         />
// //     //       </div>
// //     //       <Button

// //     //         style={{ background: "#06513D",color:"#fff" }}
// //     //         className="text-sm font-light w-40 py-5"
// //     //         onClick={handleOpenAddNew}
// //     //       >
// //     //         + Add New
// //     //       </Button>
// //     //     </div>

// //     //     <Tables
// //     //       data={tableData}
// //     //       headers={headers}
// //     //       // pageSize={pageSize}
// //     //       // total={totalRecords}
// //     //       // current={currentPage}
// //     //       // onChange={handlePageChange}
// //     //       // onSort={handleSort}
// //     //     />
// //     //     {openAddNew && (
// //     //       <AddNewSubSection
// //     //         onOpen={openAddNew}
// //     //         onClose={() => {
// //     //           setOpenAddnew(false);
// //     //         }}
// //     //         sectionId={sectionId}
// //     //         setSubSectionCreated={setSubSectionCreated}
// //     //       />
// //     //     )}
// //     //     {openUpdate && (
// //     //       <UpdateSubSection
// //     //         onOpen={openUpdate}
// //     //         onClose={() => {
// //     //           setOpenUpdate(false);
// //     //         }}
// //     //         setsubSectionUpdated={setSubSectionUpdated}
// //     //         subSectionId={subSectionId}
// //     //         subSectionName={subSectionName}
// //     //       />
// //     //     )}
// //     //   </div>
// //     // </div>

// //     <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
// //       {/* Breadcrumbs */}
// //       <div className="flex flex-wrap justify-end text-xs font-light gap-1 sm:gap-2 mt-4 h-5">
// //         <p>Home</p>
// //         <span>/</span>
// //         <p>My Question Bank</p>
// //         <span>/</span>
// //         <p>Section</p>
// //         <span>/</span>
// //         <TextStyles style={{ color: "#06513D" }}>Sub Section</TextStyles>
// //       </div>

// //       {/* Title & Back */}
// //       <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
// //         <IoArrowBackCircleOutline
// //           onClick={() => navigate(-1)}
// //           className="w-7 h-7 sm:w-10 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
// //         />
// //         <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] font-bold leading-none tracking-tight">
// //           Sub Sections (Demo 155)
// //         </div>
// //       </div>

// //       {/* Main Card */}
// //       <div
// //         className="rounded-xl shadow-md pt-4 sm:pt-6 pb-4 bg-white"
// //         style={{
// //           border: "1px solid #3BA2B959",
// //           boxShadow: "0px 0px 16px 0px #3BA2B91F",
// //         }}
// //       >
// //         {/* Top Bar */}
// //         <div className="flex flex-col md:flex-row justify-between gap-4 px-4 sm:px-8 mb-4">
// //           {/* Left */}
// //           <div className="flex flex-col sm:flex-row gap-3 sm:items-center w-full sm:w-auto">
// //             <div className="px-6 sm:px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-sm sm:text-base font-light whitespace-nowrap">
// //               Total Sub Sections {tableData.length}
// //             </div>
// //             <SearchBar
// //               onSearch={(value) => setSearchTerm(value)}
// //               width="100%"
// //               className="w-full sm:w-[300px]"
// //             />
// //           </div>

// //           {/* Right */}
// //           <Button
// //             style={{ background: "#06513D", color: "#fff" }}
// //             className="text-sm font-light w-full sm:w-40 py-2 sm:py-1"
// //             onClick={handleOpenAddNew}
// //           >
// //             + Add New
// //           </Button>
// //         </div>

// //         {/* Table */}
// //         <div className="px-2 overflow-x-auto">
// //           <Tables
// //             data={tableData}
// //             headers={headers}
// //             // pageSize={pageSize}
// //             // total={totalRecords}
// //             // current={currentPage}
// //             // onChange={handlePageChange}
// //             // onSort={handleSort}
// //           />
// //         </div>

// //         {/* Add / Update Modals */}
// //         {openAddNew && (
// //           <AddNewSubSection
// //             onOpen={openAddNew}
// //             onClose={() => setOpenAddnew(false)}
// //             sectionId={sectionId}
// //             setSubSectionCreated={setSubSectionCreated}
// //           />
// //         )}

// //         {openUpdate && (
// //           <UpdateSubSection
// //             onOpen={openUpdate}
// //             onClose={() => setOpenUpdate(false)}
// //             setsubSectionUpdated={setSubSectionUpdated}
// //             subSectionId={subSectionId}
// //             subSectionName={subSectionName}
// //           />
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default SubSections;
// import React, { useCallback, useEffect, useState } from "react";
// import { ReactComponent as BackIcon } from "../../../../assets/svgs/back-square.svg";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
// import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
// import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
// import { Button } from "antd";
// import AddNewSubSection from "./AddNew/AddNewSubSection";
// import { useLocation, useNavigate } from "react-router-dom";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// import { getApi } from "../../../../api/api_instance";
// import { API_URLS } from "../../../../api/apiUrls";
// import dayjs from "dayjs";
// import UpdateSubSection from "./Update/UpdateSubSection";
// import { Badge } from "../../../../components/Elements/TextStyles/Badge";
// import { IoArrowBackCircleOutline } from "react-icons/io5";
// import { AnimatePresence, motion } from "framer-motion";

// const cardVariants = {
//   hidden: { opacity: 0, y: 20 },
//   visible: { opacity: 1, y: 0 },
// };

// const SubSections = () => {
//   const [openAddNew, setOpenAddnew] = useState(false);
//   const [openUpdate, setOpenUpdate] = useState(false);
//   const navigate = useNavigate();
//   const [tableData, setTableData] = useState([]);
//   const [sortOrder, setSortOrder] = useState("-createdAt");
//   const [subSectionId, setSubSectionId] = useState("");
//   const [subSectionName, setSubSectionName] = useState("");
//   const [subSectionCreated, setSubSectionCreated] = useState(false);
//   const [subSectionUpdated, setSubSectionUpdated] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const location = useLocation();
//   const sectionId = location.state?.sectionId || "";

//   const headers = [
//     { label: "Sr. No.", key: "serial" },
//     { label: "Sub Section", key: "subSection" },
//     { label: "Status", key: "status" },
//     { label: "Action", key: "action" },
//   ];

//   const fetchTableData = useCallback(
//     async (sectionId) => {
//       try {
//         const response = await getApi({
//           apiUrl: API_URLS.GET_SUBSECTIONS(sectionId),
//         });

//         if (response.success) {
//           setTableData(
//             response.data.map((item, index) => ({
//               key: item._id,
//               serial: index + 1,
//               subSection: item.name,
//               createdOn: dayjs(item.createdAt).format("DD/MM/YYYY"),
//               statusText: item.status || "ACTIVE",
//               status: <Badge text={item.status || "ACTIVE"} />,
//               action: (
//                 <div className="flex gap-4 items-center">
//                   <EyeIcon
//                     className="cursor-pointer"
//                     style={{ fontSize: "18px" }}
//                     onClick={() => {
//                       navigate(
//                         "/organization/my-question-bank/sub-section/questions",
//                         {
//                           state: {
//                             subSectionId: item._id,
//                             sectionId: sectionId,
//                           },
//                         }
//                       );
//                     }}
//                   />
//                   <EditIcon
//                     className="cursor-pointer"
//                     style={{ fontSize: "18px" }}
//                     onClick={() => {
//                       setOpenUpdate(true);
//                       setSubSectionId(item._id);
//                       setSubSectionName(item.name);
//                     }}
//                   />
//                   <CustomSwitch
//                     checked={true} // Replace with actual status if needed
//                     onChange={(checked) =>
//                       console.log(`Custom switch toggled, Status: ${checked}`)
//                     }
//                   />
//                 </div>
//               ),
//             }))
//           );
//         }
//       } catch (error) {
//         console.error("Error in fetching table data", error);
//       }
//     },
//     [subSectionCreated]
//   );

//   const handleOpenAddNew = () => {
//     setOpenAddnew(true);
//   };

//   useEffect(() => {
//     if (sectionId) {
//       fetchTableData(sectionId);
//     }
//   }, [fetchTableData, subSectionUpdated, subSectionCreated, sectionId]);

//   const handleBack = () => {
//     navigate("/organization/my-question-bank");
//   };

//   return (
//     <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       {/* Breadcrumbs */}
//       <div className="flex flex-wrap justify-end text-xs font-light gap-1 sm:gap-2 mt-4 h-5">
//         <p>Home</p>
//         <span>/</span>
//         <p>My Question Bank</p>
//         <span>/</span>
//         <p>Section</p>
//         <span>/</span>
//         <TextStyles style={{ color: "#06513D" }}>Sub Section</TextStyles>
//       </div>

//       {/* Title & Back */}
//       <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//         <IoArrowBackCircleOutline
//           onClick={() => navigate(-1)}
//           className="w-7 h-7 sm:w-10 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer"
//         />
//         <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] font-bold leading-none tracking-tight">
//           Sub Sections (Demo 155)
//         </div>
//       </div>

//       {/* Main Card */}
//       <div
//         className="rounded-xl shadow-md pt-4 sm:pt-6 pb-4 bg-white"
//         style={{
//           border: "1px solid #3BA2B959",
//           boxShadow: "0px 0px 16px 0px #3BA2B91F",
//         }}
//       >
//         {/* Top Bar */}
//         <div className="flex flex-col md:flex-row justify-between gap-4 px-4 sm:px-8 mb-4">
//           {/* Left */}
//           <div className="flex flex-col sm:flex-row gap-3 sm:items-center w-full sm:w-auto">
//             <div className="px-6 sm:px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-sm sm:text-base font-light whitespace-nowrap">
//               Total Sub Sections {tableData.length}
//             </div>
//             <SearchBar
//               onSearch={(value) => setSearchTerm(value)}
//               width="100%"
//               className="w-full sm:w-[300px]"
//             />
//           </div>

//           {/* Right */}
//           <Button
//             style={{ background: "#06513D", color: "#fff" }}
//             className="text-sm font-light w-full sm:w-40 py-2 sm:py-1"
//             onClick={handleOpenAddNew}
//           >
//             + Add New
//           </Button>
//         </div>

//         {/* Card View for Mobile */}
//         <div className="px-2">
//           <AnimatePresence>
//             {tableData.map((item) => (
//               <motion.div
//                 key={item.key}
//                 initial="hidden"
//                 animate="visible"
//                 exit="hidden"
//                 variants={cardVariants}
//                 transition={{ duration: 0.3 }}
//                 className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-300"
//               >
//                 {/* Sub Section Name */}
//                 <div className="flex justify-between mb-2">
//                   <span className="font-semibold text-[#06513D]">Sub Section</span>
//                   <span className="font-semibold text-[#06513D]">{item.subSection}</span>
//                 </div>

//                 {/* Status */}
//                 <div className="flex justify-between items-center mb-3">
//                   <span>Status</span>
//                   <Badge text={item.statusText} />
//                 </div>

//                 {/* Actions and Switch */}
//                 <div className="flex justify-between items-center">
//                   <div className="flex gap-4">
//                     <EyeIcon
//                       className="cursor-pointer"
//                       onClick={() => {
//                         navigate("/organization/my-question-bank/sub-section/questions", {
//                           state: { subSectionId: item.key, sectionId: sectionId },
//                         });
//                       }}
//                     />
//                     <EditIcon
//                       className="cursor-pointer"
//                       onClick={() => {
//                         setOpenUpdate(true);
//                         setSubSectionId(item.key);
//                         setSubSectionName(item.subSection);
//                       }}
//                     />
//                   </div>
//                   <CustomSwitch
//                     checked={true} // Replace with actual status if needed
//                     onChange={(checked) =>
//                       console.log(`Custom switch toggled, Status: ${checked}`)
//                     }
//                   />
//                 </div>
//               </motion.div>
//             ))}
//           </AnimatePresence>
//         </div>

//         {/* Add / Update Modals */}
//         {openAddNew && (
//           <AddNewSubSection
//             onOpen={openAddNew}
//             onClose={() => setOpenAddnew(false)}
//             sectionId={sectionId}
//             setSubSectionCreated={setSubSectionCreated}
//           />
//         )}

//         {openUpdate && (
//           <UpdateSubSection
//             onOpen={openUpdate}
//             onClose={() => setOpenUpdate(false)}
//             setsubSectionUpdated={setSubSectionUpdated}
//             subSectionId={subSectionId}
//             subSectionName={subSectionName}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default SubSections;

import React, { useCallback, useEffect, useState } from "react";
import { ReactComponent as BackIcon } from "../../../../assets/svgs/back-square.svg";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
import { Button } from "antd";
import AddNewSubSection from "./AddNew/AddNewSubSection";
import { useLocation, useNavigate } from "react-router-dom";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import { getApi } from "../../../../api/api_instance";
import { API_URLS } from "../../../../api/apiUrls";
import dayjs from "dayjs";
import UpdateSubSection from "./Update/UpdateSubSection";
import { Badge } from "../../../../components/Elements/TextStyles/Badge";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { AnimatePresence, motion } from "framer-motion";
import { Tables } from "../../../../components/Elements/Tables/Tables";
const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const SubSections = () => {
  const [openAddNew, setOpenAddnew] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [subSectionId, setSubSectionId] = useState("");
  const [subSectionName, setSubSectionName] = useState("");
  const [subSectionCreated, setSubSectionCreated] = useState(false);
  const [subSectionUpdated, setSubSectionUpdated] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const sectionId = location.state?.sectionId || "";

  // Responsive state to detect mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Sub Section", key: "subSection" },
    { label: "Status", key: "status" },
    { label: "Action", key: "action" },
  ];

  // const fetchTableData = useCallback(
  //   async (sectionId,search ="") => {
  //     try {
  //       const response = await getApi({
  //         apiUrl: API_URLS.GET_SUBSECTIONS(sectionId, search),
  //       });

  //       if (response.success) {
  //         setTableData(
  //           response.data.map((item, index) => ({
  //             key: item._id,
  //             serial: <div className="text-center">{index + 1}</div>,
  //             subSection: <div className="text-center">{item.name}</div>,
  //             createdOn: (
  //               <div className="text-center">
  //                 {dayjs(item.createdAt).format("DD/MM/YYYY")}
  //               </div>
  //             ),
  //             statusText: item.status || "ACTIVE",
  //             status: (
  //               <div className="flex gap-4 items-center justify-center">
  //                 <Badge text={item.status || "ACTIVE"} />
  //               </div>
  //             ),
  //             action: (
  //               <div className="flex gap-4 items-center justify-center">
  //                 <EyeIcon
  //                   className="cursor-pointer"
  //                   style={{ fontSize: "18px" }}
  //                   onClick={() => {
  //                     navigate(
  //                       "/organization/my-question-bank/sub-section/questions",
  //                       {
  //                         state: {
  //                           subSectionId: item._id,
  //                           sectionId: sectionId,
  //                         },
  //                       },
  //                     );
  //                   }}
  //                 />
  //                 <EditIcon
  //                   className="cursor-pointer"
  //                   style={{ fontSize: "18px" }}
  //                   onClick={() => {
  //                     setOpenUpdate(true);
  //                     setSubSectionId(item._id);
  //                     setSubSectionName(item.name);
  //                   }}
  //                 />
  //                 <CustomSwitch
  //                   checked={true} // Replace with actual status if needed
  //                   onChange={(checked) =>
  //                     console.log(`Custom switch toggled, Status: ${checked}`)
  //                   }
  //                 />
  //               </div>
  //             ),
  //           })),
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Error in fetching table data", error);
  //     }
  //   },
  //   [subSectionCreated],
  // );

  const fetchTableData = useCallback(
    async (sectionId, search = "") => {
      if (!sectionId) return; // prevent call without sectionId
      try {
        const response = await getApi({
          apiUrl: API_URLS.GET_SUBSECTIONS(sectionId, search),
        });

        if (response.success) {
          setTableData(
            response.data.map((item, index) => ({
              key: item._id,
              serial: (
                <div className="text-center" title="">
                  {index + 1}
                </div>
              ),
              subSection: (
                <div className="text-center" title="">
                  {item.name}
                </div>
              ),
              createdOn: (
                <div className="text-center" title="">
                  {dayjs(item.createdAt).format("DD/MM/YYYY")}
                </div>
              ),
              statusText: item.status || "ACTIVE",
              status: (
                <div
                  className="flex gap-4 items-center justify-center"
                  title=""
                >
                  <Badge text={item.status || "ACTIVE"} />
                </div>
              ),
              action: (
                <div
                  className="flex gap-4 items-center justify-center"
                  title=""
                >
                  <EyeIcon
                    className="cursor-pointer"
                    onClick={() =>
                      navigate(
                        "/organization/my-question-bank/sub-section/questions",
                        { state: { subSectionId: item._id, sectionId } },
                      )
                    }
                  />
                  <EditIcon
                    className="cursor-pointer"
                    onClick={() => {
                      setOpenUpdate(true);
                      setSubSectionId(item._id);
                      setSubSectionName(item.name);
                    }}
                  />
                  <CustomSwitch
                    checked={true}
                    onChange={(checked) =>
                      console.log(`Custom switch toggled, Status: ${checked}`)
                    }
                  />
                </div>
              ),
            })),
          );
        }
      } catch (error) {
        console.error("Error fetching sub-sections", error);
      }
    },
    [navigate],
  );

  const handleOpenAddNew = () => {
    setOpenAddnew(true);
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchTableData(sectionId, searchTerm); // always pass sectionId + search
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm, sectionId, fetchTableData]);

  useEffect(() => {
    if (sectionId) {
      fetchTableData(sectionId, searchTerm);
    }
  }, [fetchTableData, subSectionUpdated, subSectionCreated, sectionId]);

  const handleSearch = (value) => {
    setSearchTerm(value); // triggers debounce automatically
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchTableData(searchTerm); // call API after typing stops
    }, 500); // 500ms debounce

    return () => clearTimeout(delayDebounce); // cleanup on new typing
  }, [searchTerm, fetchTableData]);

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {/* Breadcrumbs */}
      <div className="flex flex-wrap justify-end text-xs font-light gap-1 sm:gap-2 mt-4 h-5">
        <p>Home</p>
        <span>/</span>
        <p>My Question Bank</p>
        <span>/</span>
        <p>Section</p>
        <span>/</span>
        <TextStyles style={{ color: "#06513D" }}>Sub Section</TextStyles>
      </div>

      {/* Title & Back */}
      <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
        <IoArrowBackCircleOutline
          onClick={() => navigate(-1)}
          className="w-7 h-7 sm:w-10 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer"
        />
        <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] font-bold leading-none tracking-tight">
          Sub Sections (Demo 155)
        </div>
      </div>

      {/* Main Card */}
      <div
        className="rounded-xl shadow-md pt-4 sm:pt-6 pb-4 bg-white"
        style={{
          border: "1px solid #3BA2B959",
          boxShadow: "0px 0px 16px 0px #3BA2B91F",
        }}
      >
        {/* Top Bar */}
        <div className="flex flex-col md:flex-row justify-between gap-4 px-4 sm:px-8 mb-4">
          {/* Left */}
          <div className="flex flex-col sm:flex-row gap-3 sm:items-center w-full sm:w-auto">
            <div className="px-6 sm:px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-sm sm:text-base font-light whitespace-nowrap">
              Total Sub Sections {tableData.length}
            </div>
            <SearchBar
              onSearch={handleSearch}
              width="100%"
              className="w-full sm:w-[300px]"
            />
          </div>

          {/* Right */}
          <Button
            style={{ background: "#06513D", color: "#fff" }}
            className="text-sm font-light w-full sm:w-40 py-2 sm:py-1"
            onClick={handleOpenAddNew}
          >
            + Add New
          </Button>
        </div>

        {/* Responsive Table or Card */}
        <div className="px-2 overflow-x-auto">
          {isMobile ? (
            // MOBILE: Card View
            <AnimatePresence>
              {tableData.map((item) => (
                <motion.div
                  key={item.key}
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  variants={cardVariants}
                  transition={{ duration: 0.3 }}
                  className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-300"
                >
                  {/* Sub Section Name */}
                  <div className="flex justify-between mb-2">
                    <span className="font-semibold text-[#06513D]">
                      Sub Section
                    </span>
                    <span className="font-semibold text-[#06513D]">
                      {item.subSection}
                    </span>
                  </div>

                  {/* Status */}
                  <div className="flex justify-between items-center mb-3">
                    <span>Status</span>
                    <Badge text={item.statusText} />
                  </div>

                  {/* Actions and Switch */}
                  <div className="flex justify-between items-center">
                    <div className="flex gap-4">
                      <EyeIcon
                        className="cursor-pointer"
                        onClick={() => {
                          navigate(
                            "/organization/my-question-bank/sub-section/questions",
                            {
                              state: {
                                subSectionId: item.key,
                                sectionId: sectionId,
                              },
                            },
                          );
                        }}
                      />
                      <EditIcon
                        className="cursor-pointer"
                        onClick={() => {
                          setOpenUpdate(true);
                          setSubSectionId(item.key);
                          setSubSectionName(item.subSection);
                        }}
                      />
                    </div>
                    <CustomSwitch
                      checked={true} // Replace with actual status if needed
                      onChange={(checked) =>
                        console.log(`Custom switch toggled, Status: ${checked}`)
                      }
                    />
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          ) : (
            // DESKTOP: Table View
            <Tables
              data={tableData}
              headers={headers}
              // pageSize, total, current, onChange, onSort can be added if needed
            />
          )}
        </div>

        {/* Add / Update Modals */}
        {openAddNew && (
          <AddNewSubSection
            onOpen={openAddNew}
            onClose={() => {
              setOpenAddnew(false);
              fetchTableData();
            }}
            sectionId={sectionId}
            setSubSectionCreated={setSubSectionCreated}
          />
        )}

        {openUpdate && (
          <UpdateSubSection
            onOpen={openUpdate}
            onClose={() => setOpenUpdate(false)}
            setsubSectionUpdated={setSubSectionUpdated}
            subSectionId={subSectionId}
            subSectionName={subSectionName}
          />
        )}
      </div>
    </div>
  );
};

export default SubSections;
